import { useState } from 'react';
import { HelpIcon } from './HelpIcon';
import { Plus, Trash2 } from 'lucide-react';

export function GridField({ id, label, value = [], onChange, error, helpText, required, readOnly, columns = [] }) {
  const rows = Array.isArray(value) ? value : [];

  const addRow = () => {
    const newRow = columns.reduce((acc, col) => ({ ...acc, [col.key]: col.type === 'number' ? 0 : '' }), {});
    onChange([...rows, newRow]);
  };

  const removeRow = (index) => {
    const next = [...rows];
    next.splice(index, 1);
    onChange(next);
  };

  const updateCell = (rowIndex, key, val) => {
    const next = [...rows];
    next[rowIndex] = { ...next[rowIndex], [key]: val };
    onChange(next);
  };

  return (
    <div className="fw" style={{ gridColumn:'1 / -1' }}>
      <label className="fl">
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <div className="grid-container" style={{ border:'1px solid #e2e8f0', borderRadius:'8px', overflow:'hidden', marginTop:'0.5rem' }}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.875rem' }}>
          <thead style={{ background:'#f8fafc', borderBottom:'1px solid #e2e8f0' }}>
            <tr>
              <th style={{ width:'40px', padding:'8px' }}>#</th>
              {columns.map(col => <th key={col.key} style={{ textAlign:'left', padding:'8px', fontWeight:600 }}>{col.label}</th>)}
              {!readOnly && <th style={{ width:'40px', padding:'8px' }}></th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx} style={{ borderBottom:'1px solid #f1f5f9' }}>
                <td style={{ textAlign:'center', color:'#64748b' }}>{idx + 1}</td>
                {columns.map(col => (
                  <td key={col.key} style={{ padding:'4px 8px' }}>
                    <input type={col.type} className="field-input" style={{ height:'32px', border:'none', background:'transparent' }}
                      value={row[col.key] ?? ''} readOnly={readOnly}
                      onChange={e => updateCell(idx, col.key, col.type === 'number' ? Number(e.target.value) : e.target.value)} />
                  </td>
                ))}
                {!readOnly && (
                  <td style={{ textAlign:'center' }}>
                    <button type="button" onClick={() => removeRow(idx)} style={{ color:'#ef4444', background:'none', border:'none', cursor:'pointer', padding:'4px' }}>
                      <Trash2 size={14} />
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        {!readOnly && (
          <div style={{ padding:'8px', borderTop:'1px solid #e2e8f0', background:'#f8fafc' }}>
            <button type="button" onClick={addRow} className="btn btn-sec" style={{ padding:'4px 12px', fontSize:'0.75rem', display:'flex', alignItems:'center', gap:'4px' }}>
              <Plus size={14} /> Add Line Item
            </button>
          </div>
        )}
      </div>
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
